/* ==========================================================================
   KIRO · AIRY MATTE PDP · LIPSTICK SWATCH ANIMATION
   File name: kiro-v3-story-doodle.js
   --------------------------------------------------------------------------
   DO NOT EDIT. This file REPLACES the existing kiro-v3-story-doodle.js in
   the theme's Assets folder (the page already loads it).
   It loads kp-lipswatch.css from the same Assets folder automatically.
   Works on desktop and mobile. Full steps: open INSTALL.html.
   ========================================================================== */
(function () {
  'use strict';

  /* ---- styles ----
     Loads kp-lipswatch.css from the same Assets folder as this file.
     If that file is missing for any reason, a built-in copy is used,
     so the page always looks right. */
  var THIS_SCRIPT = document.currentScript;
  var BUILT_IN_CSS = "/* 1. Hide the old swirl/doodle. It stays in the page (hidden) because the\n      theme's own script still updates it; the new swatch replaces it. */\nkiro-product-page-v3 .kp-story-art svg:not(.kp-lipswatch) {\n  visibility: hidden !important;\n  opacity: 0 !important;\n}\n\n/* 2. Let the swatch spill out of the image column and over the text column */\nkiro-product-page-v3 .kp-story-art {\n  overflow: visible !important;\n}\n\n/* 2b. ...but never past the screen edge (no sideways page scroll). */\nkiro-product-page-v3 .kp-story {\n  overflow-x: clip;\n}\n@supports not (overflow: clip) {\n  kiro-product-page-v3 .kp-story {\n    clip-path: inset(0);\n  }\n}\n\n/* 3. The new swatch layer (desktop box = same box as the product image) */\nkiro-product-page-v3 .kp-story-art svg.kp-lipswatch {\n  position: absolute !important;\n  top: 0 !important;\n  left: -20% !important;\n  width: 140% !important;\n  height: 100% !important;\n  max-width: none !important;\n  transform: none !important;\n  overflow: visible !important;\n  z-index: 0;\n  pointer-events: none;\n}\n\n/* 4. Product image: still, fully opaque and IN FRONT of the swatch */\nkiro-product-page-v3 .kp-story-art img[data-kp-story-img] {\n  position: relative;\n  z-index: 1;\n  mix-blend-mode: normal !important;\n  transform: none !important;\n  will-change: auto !important;\n}\n\n/* 5. Text sits above the swatch so it stays readable */\nkiro-product-page-v3 .kp-story-text {\n  position: relative;\n  z-index: 2;\n}\n\n/* 6. Desktop: tighter text block (less empty space above/below the text) */\n@media (min-width: 701px) {\n  kiro-product-page-v3 .kp-story-text {\n    justify-content: center;\n    gap: 28px;\n    padding: 0;\n    top: 74px;\n  }\n  kiro-product-page-v3 .kp-motion .kp-story-copy {\n    flex: 0 0 auto;\n  }\n  kiro-product-page-v3 .kp-story-nav {\n    margin-top: 0;\n  }\n}\n\n/* 7. Mobile: product on top, text below, so the section fills the screen */\n@media (max-width: 700px) {\n  kiro-product-page-v3 .kp-story-pin,\n  kiro-product-page-v3 .kp-motion .kp-story-pin {\n    grid-template-columns: 1fr !important;\n    gap: 6px !important;\n    padding: 6px 18px 10px !important;\n  }\n  kiro-product-page-v3 .kp-story-art {\n    height: min(46svh, 92vw) !important;\n    width: 100%;\n    align-self: stretch !important;\n  }\n  kiro-product-page-v3 .kp-story-art img[data-kp-story-img] {\n    width: 100% !important;\n    height: 100% !important;\n    margin-left: 0 !important;\n    object-fit: contain;\n  }\n  kiro-product-page-v3 .kp-story-art svg.kp-lipswatch {\n    left: 0 !important;\n    width: 100% !important;\n  }\n  kiro-product-page-v3 .kp-story-text {\n    padding: 0 !important;\n    gap: 10px;\n  }\n  kiro-product-page-v3 .kp-story-nav {\n    margin-top: 6px;\n  }\n  kiro-product-page-v3 .kp-story-number {\n    bottom: 4px;\n  }\n}";
  function useBuiltInStyles() {
    if (document.getElementById('kp-lipswatch-styles-inline')) return;
    var style = document.createElement('style');
    style.id = 'kp-lipswatch-styles-inline';
    style.textContent = BUILT_IN_CSS;
    (document.head || document.documentElement).appendChild(style);
  }
  (function loadStyles() {
    if (document.getElementById('kp-lipswatch-styles')) return;
    var src = THIS_SCRIPT && THIS_SCRIPT.src;
    if (!src) { useBuiltInStyles(); return; }
    var link = document.createElement('link');
    link.id = 'kp-lipswatch-styles';
    link.rel = 'stylesheet';
    link.href = src.split('?')[0].replace(/[^\/]+$/, 'kp-lipswatch.css');
    link.onerror = useBuiltInStyles;
    (document.head || document.documentElement).appendChild(link);
  })();

  /* ---------------- settings (already tuned — do not change) ---------------- */
  var WIDTH = 92;                 // swatch thickness (600 x 600 drawing units)
  var START_AT = 0.85;            // starts when the section top is 85% down the screen
  var MOBILE_QUERY = '(max-width: 700px)';
  var PATH_DESKTOP =
    'M 140 130 C 360 70, 690 110, 770 185 C 820 232, 740 256, 620 246 ' +
    'C 440 232, 230 280, 250 385 C 268 470, 520 500, 820 520';
  var PATH_MOBILE =
    'M 170 70 C 330 40, 470 110, 440 200 C 410 290, 170 250, 180 350 ' +
    'C 190 450, 470 410, 460 510 C 452 600, 330 640, 300 715';
  var FALLBACK_STOPS = [[178, 137, 131], [148, 92, 83], [112, 61, 52]]; // Nutmeg Nude 12
  /* -------------------------------------------------------------------------- */

  var NS = 'http://www.w3.org/2000/svg';
  var SAMPLES = 320;
  var BIG = { filterUnits: 'userSpaceOnUse', x: -400, y: -400, width: 1400, height: 1400 };

  function el(tag, attrs, parent) {
    var n = document.createElementNS(NS, tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  function assign(a, b) { var o = {}, k; for (k in a) o[k] = a[k]; for (k in b) o[k] = b[k]; return o; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function ease(x) { return x * x * (3 - 2 * x); }
  function mix(c, t, f) { return c.map(function (v, i) { return Math.round(v + (t[i] - v) * f); }); }
  function rgb(c) { return 'rgb(' + c.join(',') + ')'; }

  function setup(story, index) {
    if (story.__kpLipswatch) return;
    var art = story.querySelector('.kp-story-art');
    var pin = story.querySelector('.kp-story-pin') || story;
    if (!art) return;
    story.__kpLipswatch = true;

    /* the theme's own script updates [data-kp-paint] on every scroll;
       make sure one exists so it never throws */
    var host = story.closest('kiro-product-page-v3') || document;
    if (!host.querySelector('[data-kp-paint]')) {
      var dummy = el('svg', { 'aria-hidden': 'true', style: 'display:none' });
      el('path', { 'data-kp-paint': '', d: 'M0 0' }, dummy);
      art.appendChild(dummy);
    }

    var uid = 'kpls' + index;
    var mq = window.matchMedia(MOBILE_QUERY);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* our own SVG layer, placed behind the product image */
    var svg = el('svg', {
      class: 'kp-lipswatch',
      viewBox: '0 0 600 600',
      preserveAspectRatio: 'xMidYMid meet',
      'aria-hidden': 'true',
      focusable: 'false'
    });
    art.insertBefore(svg, art.firstChild);

    var reveal = null;
    var length = 1;

    /* shade colours come from the theme's gradient (updated on shade change) */
    function readStops() {
      var grad = story.querySelector('.kp-story-art linearGradient');
      var stops = grad ? grad.querySelectorAll('stop') : [];
      if (stops.length < 3) return FALLBACK_STOPS;
      var out = [];
      for (var i = 0; i < 3; i++) {
        var m = (stops[i].getAttribute('stop-color') || '').match(/\d+/g);
        if (!m || m.length < 3) return FALLBACK_STOPS;
        out.push([+m[0], +m[1], +m[2]]);
      }
      return out;
    }

    function build() {
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      var W = WIDTH;
      var D = mq.matches ? PATH_MOBILE : PATH_DESKTOP;

      var defs = el('defs', {}, svg);
      function blur(id, sd) { var f = el('filter', assign(BIG, { id: id }), defs); el('feGaussianBlur', { stdDeviation: sd }, f); }
      blur(uid + '-shadow', W * 0.09);
      blur(uid + '-mid', W * 0.05);
      blur(uid + '-fine', 0.7);

      var mask = el('mask', { id: uid + '-mask', maskUnits: 'userSpaceOnUse', x: -400, y: -400, width: 1400, height: 1400 }, defs);
      reveal = el('path', {
        d: D, fill: 'none', stroke: '#fff', 'stroke-width': (W * 1.3).toFixed(1),
        'stroke-linecap': 'round', 'stroke-linejoin': 'round', pathLength: '100'
      }, mask);
      reveal.style.strokeDasharray = '100 300';
      length = reveal.getTotalLength() || 1;

      /* sample the centre line */
      var pts = [], i;
      for (i = 0; i <= SAMPLES; i++) {
        var t = i / SAMPLES, p = reveal.getPointAtLength(t * length);
        pts.push({ x: p.x, y: p.y, t: t });
      }
      pts.forEach(function (p, idx) {
        var a = pts[Math.max(0, idx - 2)], b = pts[Math.min(SAMPLES, idx + 2)];
        var dx = b.x - a.x, dy = b.y - a.y, m = Math.hypot(dx, dy) || 1;
        p.nx = -dy / m; p.ny = dx / m; p.tx = dx / m; p.ty = dy / m;
        var st = p.t < 0.06 ? 0.78 + 0.22 * ease(p.t / 0.06) : 1;
        var tl = p.t > 0.8 ? 1 - 0.72 * ease((p.t - 0.8) / 0.2) : 1;
        p.w = W * st * tl;
        p.s = clamp((p.nx * 0.45 + p.ny * 0.89) * 2.5, -1, 1); // which side faces the light
      });
      pts.forEach(function (p, idx) {
        var a = pts[Math.max(0, idx - 1)], b = pts[Math.min(SAMPLES, idx + 1)];
        p.s2 = (a.s + p.s * 2 + b.s) / 4;
      });
      pts.forEach(function (p) { p.s = p.s2; });

      function off(k, i0, i1, lit) {
        i0 = i0 || 0; i1 = (i1 === undefined) ? SAMPLES : i1;
        return pts.slice(i0, i1 + 1).map(function (p) {
          var kk = lit ? k * clamp(p.s * 1.4, -1, 1) : k;
          return [p.x + p.nx * p.w * kk, p.y + p.ny * p.w * kk];
        });
      }
      function toPath(arr) { return 'M' + arr.map(function (q) { return q[0].toFixed(2) + ' ' + q[1].toFixed(2); }).join(' L'); }
      function cap(p, dir) {
        var r = p.w / 2, o = [];
        for (var k = 1; k < 16; k++) {
          var g = Math.PI * k / 16, c = Math.cos(g), s = Math.sin(g);
          o.push([p.x + r * (p.nx * c + dir * p.tx * s), p.y + r * (p.ny * c + dir * p.ty * s)]);
        }
        return o;
      }
      function seg(a, b) { return [Math.floor(SAMPLES * a), Math.floor(SAMPLES * b)]; }

      var outline = toPath(
        off(0.5).concat(cap(pts[SAMPLES], 1)).concat(off(-0.5).reverse()).concat(cap(pts[0], -1).reverse())
      ) + ' Z';

      var clip = el('clipPath', { id: uid + '-clip' }, defs);
      el('path', { d: outline }, clip);

      /* colours */
      var stops = readStops();
      var base = mix(mix(stops[1], stops[2], 0.5), [150, 40, 45], 0.12);
      var deep = mix(base, [25, 6, 6], 0.55);
      var shade = mix(base, [40, 10, 10], 0.3);
      var light = mix(base, [255, 232, 225], 0.45);

      /* layers */
      var g = el('g', { mask: 'url(#' + uid + '-mask)' }, svg);
      el('path', {
        d: outline, fill: 'rgb(30,8,8)', opacity: 0.12, filter: 'url(#' + uid + '-shadow)',
        transform: 'translate(' + (W * 0.04).toFixed(1) + ' ' + (W * 0.1).toFixed(1) + ')'
      }, g);
      el('path', { d: outline, fill: rgb(base) }, g);

      var cg = el('g', { 'clip-path': 'url(#' + uid + '-clip)' }, g);
      // thickness at the edges
      el('path', { d: outline, fill: 'none', stroke: rgb(shade), 'stroke-width': (W * 0.12).toFixed(1), opacity: 0.4, filter: 'url(#' + uid + '-mid)' }, cg);
      el('path', { d: toPath(off(0.44, seg(0.02, 0.98)[0], seg(0.02, 0.98)[1], true)), fill: 'none', stroke: rgb(light), 'stroke-width': (W * 0.035).toFixed(1), 'stroke-linecap': 'round', opacity: 0.28, filter: 'url(#' + uid + '-fine)' }, cg);
      el('path', { d: toPath(off(-0.46, seg(0.02, 0.98)[0], seg(0.02, 0.98)[1], true)), fill: 'none', stroke: rgb(deep), 'stroke-width': (W * 0.025).toFixed(1), 'stroke-linecap': 'round', opacity: 0.3, filter: 'url(#' + uid + '-fine)' }, cg);

      // fine brush ridges
      var sd = 21;
      function rn() { sd = (sd * 16807) % 2147483647; return sd / 2147483647; }
      function ridge(a, b, n) {
        for (var k = 0; k < n; k++) {
          var o = -0.42 + 0.84 * (k + rn() * 0.5) / n;
          var aa = a + rn() * 0.04, bb = b - rn() * (b - a) * 0.45;
          var lt = k % 2 === 0;
          var sg = seg(aa, bb);
          el('path', {
            d: toPath(off(o, sg[0], sg[1])), fill: 'none', stroke: lt ? rgb(light) : rgb(deep),
            'stroke-width': (0.7 + rn() * 0.7).toFixed(2), 'stroke-linecap': 'round',
            opacity: lt ? 0.22 : 0.2, filter: 'url(#' + uid + '-fine)'
          }, cg);
        }
      }
      ridge(0.0, 0.13, 12);
      ridge(0.47, 0.56, 8);
      ridge(0.8, 0.99, 12);

      // tiny glints
      [[0.1, 0.25], [0.52, 0.18], [0.9, 0.1]].forEach(function (gl) {
        var p = pts[Math.floor(SAMPLES * gl[0])];
        var x = p.x + p.nx * p.w * gl[1], y = p.y + p.ny * p.w * gl[1];
        el('ellipse', {
          cx: x.toFixed(1), cy: y.toFixed(1), rx: (W * 0.028).toFixed(1), ry: (W * 0.014).toFixed(1),
          fill: '#fff', opacity: 0.75,
          transform: 'rotate(' + (Math.atan2(p.ty, p.tx) * 180 / Math.PI).toFixed(0) + ' ' + x.toFixed(1) + ' ' + y.toFixed(1) + ')'
        }, cg);
      });

      draw();
    }

    /* scroll-linked drawing */
    var frame = 0;
    function draw() {
      frame = 0;
      if (!reveal) return;
      var capPct = (WIDTH * 1.3 / 2) / length * 100 + 1;
      var p = 1;
      if (!reduce.matches && story.classList.contains('kp-motion')) {
        var header = parseFloat(getComputedStyle(story).getPropertyValue('--kp-header')) || 0;
        var travel = Math.max(1, story.offsetHeight - pin.offsetHeight);
        var startTop = window.innerHeight * START_AT;
        var endTop = header - travel;
        p = clamp((startTop - story.getBoundingClientRect().top) / (startTop - endTop), 0, 1);
      }
      reveal.style.strokeDashoffset = ((100 + capPct) * (1 - p)).toFixed(2);
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(draw); }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if (mq.addEventListener) mq.addEventListener('change', build); else if (mq.addListener) mq.addListener(build);
    if (reduce.addEventListener) reduce.addEventListener('change', schedule);

    /* re-colour when the shade changes */
    var grad = story.querySelector('.kp-story-art linearGradient');
    if (grad && window.MutationObserver) {
      var t = 0;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(build, 30); })
        .observe(grad, { subtree: true, attributes: true, attributeFilter: ['stop-color'] });
    }

    build();
  }

  function init() {
    var stories = document.querySelectorAll('kiro-product-page-v3 [data-kp-story]');
    for (var i = 0; i < stories.length; i++) setup(stories[i], i);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', function () {
    init();                                                    // in case the section renders late
    window.dispatchEvent(new Event('resize'));                 // let the theme re-measure the new layout
  });
  document.addEventListener('shopify:section:load', init);     // Shopify theme editor
})();
